import React from "react";
import ResetPassword from "./views/ResetPassword";
import { ResetPasswordContextProvider } from "./ResetPasswordView";

const ResetPasswordIntent = () => {
  return (
    <ResetPasswordContextProvider>
      <ResetPassword />
    </ResetPasswordContextProvider>
  );
};

export default ResetPasswordIntent;